import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "components/Button";
import { cn } from "utils";

const PrefillPitch = ({
  field,
  className,
  editorLabel,
  editorSubLabel,
  onSubmit,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [objectField, setObjectField] = useState({
    value: field,
    successMessage: "",
    errorMessage: "",
  });

  const handleChange = (value) => {
    setObjectField((prev) => ({
      ...prev,
      value,
      errorMessage: "",
      successMessage: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) {
      return;
    }

    setSubmitting(true);
    const res = await onSubmit(objectField);
    let successMessage = "";
    let errorMessage = "";

    if (res.isSuccess) {
      successMessage = "update successful";
    } else {
      errorMessage = "Something went wrong";
    }
    setObjectField((prev) => ({
      ...prev,
      successMessage,
      errorMessage,
    }));

    setTimeout(() => {
      setObjectField((prev) => ({
        ...prev,
        successMessage: "",
        errorMessage: "",
      }));
    }, 2000);

    setSubmitting(false);
  };

  return (
    <div className={cn("flex flex-col", className)}>
      <form onSubmit={handleSubmit}>
        {editorLabel && (
          <p className="font-inter text-base font-medium text-slate-700">
            {editorLabel}
          </p>
        )}

        {editorSubLabel && (
          <p className="font-normal text-base mb-4">{editorSubLabel}</p>
        )}

        <textarea
          className="mt-6 h-40 w-full rounded-md border border-solid border-slate-300 bg-white py-2 pl-3 pr-1"
          value={objectField.value}
          onChange={(e) => handleChange(e.target.value)}
          rows={6}
        />

        <div className="flex flex-col items-start">
          {objectField.successMessage && (
            <span className="text-green-600 text-sm font-bold mt-1">
              {objectField.successMessage}
            </span>
          )}

          {objectField.errorMessage && (
            <span className="text-red-600 text-sm font-bold mt-1">
              {objectField.errorMessage}
            </span>
          )}

          <Button
            type="submit"
            isReadOnly={submitting || field === objectField.value}
            className={cn(
              "mt-4 rounded-md border border-solid border-slate-300 bg-white px-4 py-2 font-inter text-sm font-medium normal-case text-slate-700 shadow-none hover:text-slate-700 hover:shadow-none",
              {
                "animate-pulse cursor-not-allowed": submitting,
              }
            )}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

PrefillPitch.propTypes = {
  field: PropTypes.string,
  className: PropTypes.string,
  borderTop: PropTypes.bool,
  editorLabel: PropTypes.string,
  editorSubLabel: PropTypes.string,
  onSubmit: PropTypes.func,
};

PrefillPitch.defaultProps = {
  field: "",
  className: "",
  borderTop: false,
  editorLabel: "",
  editorSubLabel: "",
  onSubmit: () => {},
};

export default PrefillPitch;
